import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export type BadgeVariant =
  | 'investigating'
  | 'draft'
  | 'read'
  | 'new'
  | 'closed'
  | 'custom';

export const BadgeStyled = styled.div<{
  variant: BadgeVariant;
  color?: string;
  'background-color'?: string;
  'border-color'?: string;
  capitalize?: boolean;
  width?: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px 12px;
  border-radius: 14px;
  width: fit-content;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : 'none')};
  ${(props) => {
    switch (props.variant) {
      case 'investigating':
        return props.theme.isVaultVariant
          ? `
            color: ${props.theme.atlas.semantic.color.status.success.textDefault};
            background: ${props.theme.atlas.semantic.color.status.success.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.success.default};
          `
          : `
            color: ${props.theme.atlas.semantic.color.type.default};
            background: ${props.theme.atlas.semantic.color.status.warning.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.warning.default};
          `;

      case 'draft':
        return props.theme.isVaultVariant
          ? `
            color: ${props.theme.atlas.semantic.color.status.notification.textDefault};
            background: ${props.theme.atlas.semantic.color.status.notification.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.notification.default};
          `
          : `
            color: ${props.theme.atlas.semantic.color.type.default};
            background: ${props.theme.atlas.core.color.purple[70]};
            border: solid 1px ${props.theme.atlas.core.color.purple[70]};
          `;

      case 'read':
        return props.theme.isVaultVariant
          ? `
            color: ${props.theme.atlas.semantic.color.status.neutral.text};
            background: ${props.theme.atlas.semantic.color.status.neutral.backgroundVariant};
            border: solid 1px ${props.theme.atlas.semantic.color.status.neutral.backgroundVariant};
          `
          : `
            color: ${props.theme.atlas.semantic.color.type.default};
            background: ${props.theme.atlas.semantic.color.status.notification.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.notification.default};
          `;

      case 'new':
        return props.theme.isVaultVariant
          ? `
            color: ${props.theme.atlas.semantic.color.type.default};
            background: ${props.theme.atlas.semantic.color.surface.default};
            border: solid 1px ${props.theme.atlas.semantic.color.outline.default};
          `
          : `
            color: ${props.theme.atlas.semantic.color.type.default};
            background: ${props.theme.atlas.semantic.color.status.notification.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.notification.default};
          `;

      case 'closed':
        return props.theme.isVaultVariant
          ? `
            color: ${props.theme.atlas.semantic.color.type.inverse};
            background: ${props.theme.atlas.semantic.color.surface.inverse};
            border: solid 1px ${props.theme.atlas.semantic.color.surface.inverse};
          `
          : `
            color: ${props.theme.atlas.semantic.color.status.success.textDefault};
            background: ${props.theme.atlas.semantic.color.status.success.default};
            border: solid 1px ${props.theme.atlas.semantic.color.status.success.default};
          `;

      case 'custom':
        return `
            ${
              props.color
                ? `color: ${props.color};`
                : `color: ${props.theme.atlas.semantic.color.type.default};`
            }
            ${
              props['background-color'] &&
              `background-color: ${props['background-color']};`
            }
            ${
              props['border-color'] &&
              `border: 1px solid ${props['border-color']};`
            }
            ${
              !props['border-color'] &&
              props['background-color'] &&
              `border: 1px solid ${props['background-color']};`
            }
            ${props.width && `width: ${props.width};`}
          `;
    }
  }}
`;
